export enum EStepsName {
  SUMMARY = "summary",
  INSURER = "insurer",
  CLAIM = "claim", // NEW: Claim details step for defendant/claimant flow
  TELEMATICS = "telematics",
}
